const storage = window.sessionStorage

function loadItem(key) {
  const item = storage.getItem(key)
  try {
    return JSON.parse(item)
  } catch (e) {
    storage.removeItem(key)
  }
}

function storeItem(key, value) {
  if (value) {
    storage.setItem(key, JSON.stringify(value))
  } else {
    storage.removeItem(key)
  }
}

export default {
  namespaced: true,
  state: {
    enCours: loadItem('confirmauthentification/enCours'),
  },
  getters: {
    enCours: (state) => state.enCours,
  },
  mutations: {
    enCours(state, enCours) {
      state.enCours = enCours
      storeItem('confirmauthentification/enCours', enCours)
    },
  },
}
